// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"689dfe2c","306":"95901d99","349":"fc9aad29","453":"84d3f207","463":"85cdb4d1","575":"324bdb49","760":"31608f12","839":"bcaf750b","927":"9df9eef5","990":"ff4a7324"}[chunkId] + ".chunk.js";
};